import { render, staticRenderFns } from "./QuotationStatusChip.vue?vue&type=template&id=60a9a729"
import script from "./QuotationStatusChip.vue?vue&type=script&lang=js"
export * from "./QuotationStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports